<template>
  <div class="page">
    <div class="page-container v-py-lg">
      <div class="page-title">创建大项目</div>
      <div class="w1000">
        <div class="panel">
          <div class="panel-body">
            <a-form-model class="form-sm" ref="form" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
              <a-row :gutter="0">
                <a-col span="24">
                  <a-form-model-item :colon="false" prop="name" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      项目名称
                    </span>
                    <a-input placeholder="项目名称" allowClear v-model="form.name" ref="name" />
                  </a-form-model-item>
                </a-col>
                <a-col span="12">
                  <a-form-model-item :colon="false" prop="type">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      项目类型
                    </span>
                    <a-select placeholder="选择项目类型" disabled v-model="form.type" style="width: 220px" ref="type">
                      <a-select-option :value="21">螺蛳壳改造</a-select-option>
                      <a-select-option :value="22">精灵书屋</a-select-option>
                      <a-select-option :value="23">公益人才</a-select-option>
                      <a-select-option :value="24">爱心100</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col span="12">
                  <a-form-model-item :colon="false" prop="period" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      美丽心灵管理费率
                    </span>
                    <a-input-number ref="ownManageRate" placeholder="不超过10%" class="no-handler text-right" :min="0" :max="10" :formatter="value => `${value}%`" :parser="value => value.replace('%', '')" v-model="form.ownManageRate" />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="0">
                <a-col span="12">
                  <a-form-model-item :colon="false" prop="period">
                    <span slot="label">
                      <!-- <i class="required-mark">*</i> -->
                      实施时间
                    </span>
                    <a-range-picker v-model="form.dates" format="YYYY-MM-DD" value-format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onDateRangeChange" ref="datePicker2" style="width: 220px" />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="0">
                <a-col span="24">
                  <a-form-model-item :colon="false" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                    <span slot="label">
                      <!-- <i class="required-mark">*</i> -->
                      实施地点
                    </span>
                    <template v-if="addressList.length > 0">
                      <div class="flex items-center" v-for="(item, index) in addressList" :key="index">
                        <div style="width: calc(100% - 160px)">
                          <a-input-group compact>
                            <a-cascader changeOnSelect style="width: 320px" expand-trigger="hover" :show-search="{ cascaderFilter }" :options="districts" placeholder="选择地区" v-model="item.districts" :ref="`districts-${index}`" />
                            <a-input style="width: calc(100% - 330px)" placeholder="详细地址" allowClear v-model="item.addr" :ref="`addr-${index}`" />
                          </a-input-group>
                        </div>
                        <a-space>
                          <a-button size="small" type="primary" icon="plus" title="添加" @click="onAddAddress(index + 1)"></a-button>
                          <a-button size="small" type="indigo" icon="minus" title="删除" @click="onRemoveAddress(index)" v-if="addressList.length > 1"></a-button>
                        </a-space>
                      </div>
                    </template>
                    <a-button size="small" type="primary" icon="plus" @click="onAddAddress(0)" v-else>添加实施地点</a-button>
                  </a-form-model-item>
                </a-col>
                <a-col span="24">
                  <a-form-model-item :colon="false" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                    <span slot="label">实施概要说明</span>
                    <editor v-model="form.content" :file-params="{ fileSign: 'P01', fileMark, projectId, fileType: 13 }" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-form-model>
            <div class="text-center v-my-lg">
              <a-space>
                <a-button icon="check" type="indigo" key="draft" @click="handleConfirm(false)" :loading="saving">保存初稿</a-button>
                <a-button icon="arrow-right" type="primary" key="submit" @click="handleConfirm(true)" :loading="saving">提交</a-button>
                <a-button icon="rollback" type="default" key="backward" @click="$router.push('./list')">返回</a-button>
              </a-space>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { saveMain, viewPrj } from '@/api/project/house'
import alldistricts from '@/utils/districts'
import Editor from '@/components/tinymce'

const form = {
  name: '',
  content: '',
  type: 22,
  startDate: undefined,
  endDate: undefined,
  ownManageRate: undefined,
  dates: [],
}
export default {
  name: 'HouseMainPrj',
  components: {
    Editor,
  },
  data() {
    return {
      projectId: this.$route.query.id,
      form: { ...form },
      addressList: [],
      districts: alldistricts,
      fileMark: this.$utils.uuid(),
      loading: false,
      saving: false,
    }
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.load()
      } else {
        this.onAddAddress(0)
      }
    },
    load() {
      this.loading = true
      viewPrj(this.projectId, true).then(({ data }) => {
        if (data.success) {
          let { name, type, startDate, endDate, content, addresses, ownManageRate } = data.result
          this.form = {
            name,
            type,
            dates: startDate && endDate ? [startDate.substring(0, 10), endDate.substring(0, 10)] : [],
            ownManageRate,
            content,
          }
          if (addresses.length > 0) {
            this.addressList = addresses.map(({ id, province, city, district, addr }) => {
              let districts = []
              if (province) {
                districts.push(province)
              }
              if (city) {
                districts.push(city)
              }
              if (district) {
                districts.push(district)
              }
              return {
                id,
                districts,
                addr,
              }
            })
          } else {
            this.onAddAddress()
          }
        }
        this.loading = false
      })
    },
    onDateRangeChange(date, dateString) {
      let [startDate, endDate] = dateString
      this.form.startDate = startDate ? `${startDate} 00:00` : startDate
      this.form.endDate = endDate ? `${endDate} 00:00` : endDate
    },
    onAddAddress(index = 0) {
      let len = this.addressList.length
      this.addressList.splice(index, 0, {
        seq: len + 1,
        districts: [],
        addr: '',
      })
    },
    onRemoveAddress(index) {
      this.addressList.splice(index, 1)
    },
    handleConfirm(nextStep) {
      this.$message.destroy()
      let { type, name, ownManageRate } = this.form
      this.$message.destroy()
      if (!type) {
        this.$message.warning('请选择项目类型')
        this.$refs.type.focus()
        return
      }
      if (name.trim() === '') {
        this.$message.warning('请输入项目名称')
        this.$refs.name.focus()
        return
      }
      const { isNum } = this.$utils
      if (!isNum(ownManageRate)) {
        this.$refs.ownManageRate.focus()
        this.$message.warning('请输入美丽心灵管理费率')
        return
      }
      this.$confirm({
        title: nextStep ? '确认提交？' : '确认保存初稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(nextStep)
        },
      })
    },
    handleSubmit(nextStep) {
      let { type, name, dates, content, ownManageRate } = this.form
      let { fileMark } = this
      let addresses = this.addressList.filter(item => item.districts[0])
      let params = {
        id: this.projectId,
        type,
        name,
        startDate: dates[0] ? `${dates[0]} 00:00` : undefined,
        endDate: dates[1] ? `${dates[1]} 00:00` : undefined,
        ownManageRate,
        fileMark,
        content: content.trim(),
        addresses: addresses.map(({ id, districts, addr }) => ({ id, province: districts[0], city: districts[1], district: districts[2], addr })),
        nextStep,
      }
      this.saving = true
      saveMain(params)
        .then(({ data }) => {
          if (data.success) {
            this.$message.success('操作成功')
            this.$router.push('./list')
          } else {
            this.$message.warning(data.msg)
          }
          this.saving = false
        })
        .catch(err => {
          if (err) {
            this.$message.warning(err)
          }
          this.saving = false
        })
    },
  },
  created() {
    this.init()
  },
}
</script>
